import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardActionArea, CardActions, CardContent, CardMedia } from '@material-ui/core';
import { Lightbox, colors, Typography } from 'kangarootime-ui';
import ActionButton from './GridView/ActionButton';
import Check from '../../../assets/svg/check';
import Block from '../../../assets/svg/block';

const LightboxPhoto = ({ isOpen, onClose, approvePhoto, rejectPhoto, photoDetails }) => (
  <Lightbox isOpen={isOpen} onClose={onClose}>
    <div className='flex' style={{ justifyContent: 'center', alignItems: 'center', marginTop: 32, marginBottom: 32 }} onClick={onClose}>
      <Card style={{ width: 540 }}>
        <CardActionArea>
          <CardMedia image={photoDetails.image} style={{ height: 320 }} />
          <CardContent style={{ maxHeight: 280, overflow: 'auto' }}>
            <Typography type='header'>{photoDetails.first_name} {photoDetails.last_name}</Typography>
            { photoDetails.note.description
              ? <Typography>{photoDetails.note.description}</Typography>
              : null
            }
          </CardContent>
          <CardActions style={{ justifyContent: 'flex-end' }}>
            <span style={{ color: '#808495', fontSize: 14 }}>Approve?</span>
            <ActionButton
              icon={<Check fill={colors.success} />}
              onClick={() => approvePhoto([{
                photoId: photoDetails.group_image_id,
                childId: photoDetails.child_id
              }])}
            />
            <ActionButton
              icon={<Block fill={colors.danger} />}
              onClick={() => rejectPhoto([{
                photoId: photoDetails.group_image_id,
                childId: photoDetails.child_id
              }])}
            />
          </CardActions>
        </CardActionArea>
      </Card>
    </div>
  </Lightbox>
);

Lightbox.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  approvePhoto: PropTypes.func,
  rejectPhoto: PropTypes.func,
  photoDetails: PropTypes.shape({
    child_id: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    group_image_id: PropTypes.string,
    id: PropTypes.string,
    image: PropTypes.string,
    key: PropTypes.string,
    room_name: PropTypes.string,
    note: PropTypes.shape({
      type: PropTypes.string,
      description: PropTypes.string
    })
    // may also have additional keys that aren't used
  })
};

export default LightboxPhoto;
